import { render } from "./ASymphonyOfFreshness.vue?vue&type=template&id=787156ca&scoped=true"
import script from "./ASymphonyOfFreshness.vue?vue&type=script&lang=js"
export * from "./ASymphonyOfFreshness.vue?vue&type=script&lang=js"

import "./ASymphonyOfFreshness.vue?vue&type=style&index=0&id=787156ca&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-787156ca"]])

export default __exports__